import DOMPurify, { Config } from 'dompurify'

export function sanitizeHtml(html: string | Node, config: Config) {
  return DOMPurify.sanitize(html, config)
}
